import { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { isValidLocationName } from '../BuildingDashboard/DigitalSignage/helpers'
import Icon from '../Icons'

const DigitalSignageAddNewLocationPopup = ({ open, buildingId, onClose, onSubmit }) => {
  const { t } = useTranslation(['digital-signage', 'common'])
  const [locationName, setLocationName] = useState('')
  const [isLocationValid, setIsLocationValid] = useState(false)

  const onChangeLocationName = (event) => {
    const locationName = event.target.value
    setIsLocationValid(isValidLocationName(locationName))
    if (locationName.length > 24) {
      return
    }
    setLocationName(locationName)
  }

  const onHandleSubmit = async () => {
    if (locationName.length === 0 || !buildingId) {
      return
    }
    onSubmit(buildingId, locationName)
    onClose()
    setLocationName('')
  }

  if (!open) return null

  return (
    <div className="digital-signage-popup">
      <div className="overlay" />
      <div className="popup-content add-new-location-popup">
        <div className="add_new_location_header">
          <div className="add-new-location-popup-title">
            <Icon icon="location" viewBox="0 0 18 21" />
            <div>{t('digital-signage:addNewLocationPopup.title')}</div>
          </div>
          <div onClick={onClose} className="header-cross-icon add-location-btn-cross">
            <Icon icon="cross" viewBox="0 0 20 20" />
          </div>
        </div>
        <div className="body body-add-new-location">
          <div className="content-wrapper">
            <div className="location-input-title">
              {t('digital-signage:addNewLocationPopup.locationLabel')}
            </div>
            <div>
              <input
                pattern="[A-Za-z0-9 -]+"
                className="enter-location-input"
                type="text"
                placeholder={t('digital-signage:addNewLocationPopup.locationPlaceholder')}
                value={locationName}
                onChange={onChangeLocationName}
              />
            </div>
          </div>
          <div className="body-actions">
            <button className="cancel action-button" onClick={onClose}>
              {t('common:actions.cancel')}
            </button>
            <button
              className="add-new-location-btn action-button"
              onClick={onHandleSubmit}
              disabled={!isLocationValid}
            >
              {t('digital-signage:addNewLocationPopup.submitButton')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

DigitalSignageAddNewLocationPopup.propTypes = {
  buildingId: PropTypes.number.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default DigitalSignageAddNewLocationPopup
